import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import { Checkbox, Col, DismissablePill, Pill, Row, StyleSheet, spacing } from '@coursera/coursera-ui';

const OrganizationAdmins = 'OrganizationAdmins';
const ProgramAdmins = 'ProgramAdmins';
const UserPrefix = 'User~';

const toggle = (item: string, items: string[]) =>
  items.includes(item) ? items.filter((_) => _ !== item) : items.concat(item);

const styles = StyleSheet.create({
  Pill: {
    marginBottom: spacing.sm,
    marginRight: spacing.sm,
  },
  PillContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
});

const PlagiarismEmailsRow: React.FC<{
  title: React.ReactNode;
  recipients: string[];
  setRecipients: (recipients: string[]) => void;
  recipientsOverride?: string[];
}> = ({ title, recipients = [], setRecipients, recipientsOverride = [] }) => {
  return (
    <Row alignItems="center">
      <Col md={4}>
        <Typography2 component="p">{title}</Typography2>
      </Col>
      <Col md={1}>
        <Checkbox
          disabled={recipientsOverride.includes(OrganizationAdmins)}
          checked={recipientsOverride.includes(OrganizationAdmins) || recipients.includes(OrganizationAdmins)}
          onChange={() => {
            setRecipients(toggle(OrganizationAdmins, recipients));
          }}
        />
      </Col>
      <Col md={1}>
        <Checkbox
          disabled={recipientsOverride.includes(ProgramAdmins)}
          checked={recipientsOverride.includes(ProgramAdmins) || recipients.includes(ProgramAdmins)}
          onChange={() => {
            setRecipients(toggle(ProgramAdmins, recipients));
          }}
        />
      </Col>
      <Col md={4} rootClassName={styles.PillContainer}>
        {recipients
          .filter((_) => _.startsWith(UserPrefix))
          .map((_) => _.slice(UserPrefix.length))
          .map((userId) => (
            <DismissablePill
              size="lg"
              tag="button"
              label={userId}
              onDismiss={() => {
                setRecipients(recipients.filter((_) => _ !== `${UserPrefix}${userId}`));
              }}
              rootClassName={styles.Pill}
            />
          ))}
        <Pill
          tag="button"
          label="Add User ID"
          size="lg"
          htmlAttributes={{
            onClick: () => {
              // eslint-disable-next-line no-alert
              const userId = window.prompt('Enter User ID');
              if (!userId) {
                return;
              }
              setRecipients(recipients.concat(`${UserPrefix}${userId}`));
            },
          }}
          rootClassName={styles.Pill}
        />
      </Col>
    </Row>
  );
};

export default PlagiarismEmailsRow;
